<template>
<div class="row">
  <div class="columns ">
    <div class="listing-container fadeinUp">
      <div class="member" v-for="(result, index) in results" :key="index" :class="result.type" >
        <a  v-bind:href="memPath + result.id" tabindex="0" class="inner-wrap" >
          <div class="inner">
            <p class="member-type_text">{{result.type}}</p>
            <div class="member-logo_container-wrap">
              <div v-if="result.Logo"  class="member-logo_container .object-fit-contain ">
                <img class="member-logo_image" :src="result.Logo"
            :alt="result.logo">
            <!-- <img v-else src="https://logo.clearbit.com/defaultonline.com"
            alt="default logo"> -->
              </div>
            </div>
            <div class="member-details">
              <h3 class="member-name">{{result.name}}</h3>
              <p class="member-location"><span class="city">{{result.city}}</span>, <span class="state">{{result.state}}</span></p>
              <!-- document.write("1:   " + t.replace(/^(.{1}[^\s]*).*/, "$1") + "\n"); -->
              <p v-if="result.Description && result.Description.length <= 300" class="member-description">{{result.Description.replace(/<(?:.|\n)*?>/gm, '')}}</p>
              <p v-else-if="result.Description && result.Description.length > 300" class="member-description">{{result.Description.replace(/<(?:.|\n)*?>/gm, '').replace(/\r?\n|\r/g, '').replace(/^(.{300}[^\s]*).*/, "$1")}}<span> (...)</span><span class="show-for-sr">this text continues on the member detail page, by clicking the link housing this content</span></p>
              <p v-else class="member-description">There is no description for this member</p>
              <span class="white-fill">. this is the white filler .portion to fill out the widths in Safari and IE</span>
              <div v-if="result.institutionType" class="institution-wrapper">
                <h4 class="member-institution-type">Institution Type</h4>
              <p>{{result.institutionType}}</p>
              </div>
              <div v-else class="institution-wrapper">
              </div>
              <div v-if="result.Disciplines" class="disciplines-wrapper">
                <h4 class="member-disciplines">Disciplines</h4>
              <p>{{result.Disciplines.replace(/;/gm,', ')}}</p>
              </div>
              <div v-else class="disciplines-wrapper">
              </div>
               <div class="flags">
                <span v-if="result.Has_Peer_Advisor__c" class="flag"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11">
                  <path fill="#14A973" fill-rule="evenodd" d="M128.406566,3.00024891 C128.256819,3.00497626 128.114691,3.07129225 128.010292,3.18514752 L119.195428,12.5256637 L114.991753,8.07131303 C114.847107,7.91210761 114.632589,7.84810497 114.4308,7.90395018 C114.229012,7.95979539 114.071426,8.12677835 114.018723,8.34060005 C113.966021,8.55442176 114.026422,8.78173272 114.176668,8.93500386 L118.787857,13.8211694 C119.01296,14.0596102 119.377839,14.0596102 119.602942,13.8211694 L128.82532,4.04883835 C128.995797,3.87324743 129.047056,3.60476754 128.954398,3.37276748 C128.861739,3.14076742 128.644172,2.99284088 128.406532,3.00026723 L128.406566,3.00024891 Z" transform="translate(-114 -3)"/>
                  </svg>
                Peer Advisor
                </span>
                <span v-if="result.Has_Ambassador__c" class="flag"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11">
                  <path fill="#14A973" fill-rule="evenodd" d="M128.406566,3.00024891 C128.256819,3.00497626 128.114691,3.07129225 128.010292,3.18514752 L119.195428,12.5256637 L114.991753,8.07131303 C114.847107,7.91210761 114.632589,7.84810497 114.4308,7.90395018 C114.229012,7.95979539 114.071426,8.12677835 114.018723,8.34060005 C113.966021,8.55442176 114.026422,8.78173272 114.176668,8.93500386 L118.787857,13.8211694 C119.01296,14.0596102 119.377839,14.0596102 119.602942,13.8211694 L128.82532,4.04883835 C128.995797,3.87324743 129.047056,3.60476754 128.954398,3.37276748 C128.861739,3.14076742 128.644172,2.99284088 128.406532,3.00026723 L128.406566,3.00024891 Z" transform="translate(-114 -3)"/>
                  </svg>
                Ambassador
                </span>
            </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
</template>
<script>

let memPath = memberDetailPath;

export default {
  props: [
    'results'
  ],
  data() {
    return {
      //results: results,
      memPath: memberDetailPath
    }
  },

  mounted: function() {
   

  
  }
}
</script>



// WEBPACK FOOTER //
// CMS/NationalGuild/src/js/vueComponents/MemberList.vue